export const formatModalityLabel = (modality?: { identifier?: string | null; name?: string | null } | null) => {
  if (!modality) return '';
  return `${modality.identifier} - ${modality.name}`;
};
